<template>
  <div id="app" style="--primary: #20c59f; --secondary: #5b5b5b;">
    <div class="">
      <component :is="layout">
        <router-view/>
      </component>
      <vue-snotify></vue-snotify>
    </div>

    <!-- <b-modal id="unauthorizedModal" centered size="sm" no-close-on-esc no-close-on-backdrop  ref="unauthorizedModal" hide-header hide-footer>
      <h1>Se cerró tu sesión!</h1>
      <template v-if="unauthorizedError.data">
        <h2>{{unauthorizedError.data.message}}</h2>
      </template>

      <div class="text-right">
        <button class="btn btn-secondary btn-b d-inline mr-4" style="width: auto" v-on:click="goToLogin">Ir al inicio de sesión</button>
      </div>

     </b-modal> -->
  </div>
</template>

<script>
import Vue from "vue";
import { SET_LOGOUT } from "@/store/mutations.type";

const default_layout = "default-layout";

export default Vue.extend({
  components: {},

  mounted() {
    this.getTitle(this.$route);
  },

  data() {
    return {
      unauthorizedError: {}
    };
  },
  methods: {
    unauthorized(error) {
      this.unauthorizedError = error;
      this.$refs.unauthorizedModal.show();
    },
    goToLogin() {
      this.$store.commit(SET_LOGOUT);
      setTimeout(() => {
        location.replace("/#/login");
      }, 500);
      // this.$router.replace({ name: "login" });
      // this.$refs.unauthorizedModal.hide();
    },
    getTitle(r) {
      document.title = `${r.meta.title} POS`;
    }
  },

  computed: {
    layout() {
      return `${this.$route.meta.layout || default_layout}-layout`;
    }
  },
  watch: {
    $route(to) {
      this.getTitle(to);
    }
  }
});
</script>
<style lang="scss">
@import "~vue-snotify/styles/material";
// @import "~bootstrap/dist/css/bootstrap.css";
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";

@import "assets/style.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue